import {
  getApolloClientSingleton,
  LoginDocument,
  LoginMutation,
  LoginMutationVariables,
  RefreshTokenDocument,
  RefreshTokenMutation,
  RefreshTokenMutationVariables,
} from 'vvs-gotchi-graphql'
import { ActiveWeb3React } from 'hooks/useActiveWeb3React'
import { signMessage } from 'utils/web3React'

import { AccessToken } from './models'

export const isAuthTokenValid = (accessToken?: AccessToken) =>
  accessToken && accessToken.token && accessToken.expiresAt > Date.now()

export const authenticate = async (signature: string, account: string, timestamp: number) => {
  const { data, errors } = await getApolloClientSingleton().mutate<LoginMutation, LoginMutationVariables>({
    mutation: LoginDocument,
    variables: {
      signature,
      address: account,
      timestamp,
    },
  })
  if (errors) {
    throw errors
  }
  return data?.login
}

export const refreshToken = async (accessToken: AccessToken, account: string) => {
  const { data, errors } = await getApolloClientSingleton().mutate<RefreshTokenMutation, RefreshTokenMutationVariables>(
    {
      mutation: RefreshTokenDocument,
      variables: {
        accessToken: accessToken.token,
        address: account,
        refreshToken: accessToken.refreshToken,
      },
    },
  )

  if (errors) {
    throw errors
  }
  return data?.refreshToken
}

export const signAuthMsg = async (web3React: ActiveWeb3React, account: string, timestamp: number) => {
  const { library: provider, connector } = web3React
  return signMessage(provider, account, getAuthSignMsg(account, timestamp), connector)
}

const getAuthSignMsg = (account: string, timestamp: number) =>
  `Welcome to vvsgotchi!

By connecting to your wallet and using VVSGotchi, you agree to our Terms and Conditions and Code of Conduct, and acknowledge you have read our Privacy Notice.

Your authentication status will reset after 24 hours.
address: ${account.toLowerCase()}
timestamp: ${timestamp}`

// Terms and Conditions: https://vvs.finance/about/vvsgotchi/termsandconditions.pdf
